import { QriReference } from '@qualio/search-qri';
import { useQuery, useQueryClient } from 'react-query';
import { globalSearchServiceApi } from '../../../../api/globalSearchService';

export type EmbeddedDocument = {
  name: string;
  displayLabel: string;
  identifiers: { id: string; code: string; matrixId: string };
};

export const useInvalidateEmbeddedDocuments = (qri: string) => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries(['embeddedDocuments', qri]);
};

export const useEmbeddedDocuments = (
  qri: string,
  enabled: boolean,
  companyId: number,
) => {
  return useQuery<EmbeddedDocument[]>({
    queryKey: ['embeddedDocuments', qri],
    queryFn: async () => {
      const result = await globalSearchServiceApi.getReferences(
        [qri],
        'to',
        companyId,
      );
      const embeddedDocuments = result.references.filter((ref: QriReference) =>
        ref.relationsToSubjectQris.some(
          (rel) => (rel as any).linkType === 'embedded',
        ),
      );
      const uniqueEmbeddedDocuments = new Map(
        embeddedDocuments.map((ref) => [
          (ref.identifiers as any).matrixId,
          ref,
        ]),
      );
      return [...uniqueEmbeddedDocuments.values()] as EmbeddedDocument[];
    },
    refetchOnWindowFocus: false,
    enabled,
  });
};
